import { NavLink } from 'react-router';
import { Box, BookOpen, Zap, Home, Package, Trophy } from 'lucide-react';

const items = [
  { to: '/pokemons', label: 'PC', icon: Box, end: true },
  { to: '/pokemons/pokedex', label: 'Pokédex', icon: BookOpen },
  { to: '/pokemons/fusion', label: 'Fusion', icon: Zap },
  { to: '/pokemons/pension', label: 'Pension', icon: Home },
  { to: '/pokemons/inventory', label: 'Inventaire', icon: Package },
  { to: '/pokemons/leaderboard', label: 'Classement', icon: Trophy },
];

export const PokemonsSubNav = () => {
  return (
    <nav className="bg-warm border-b border-line-soft overflow-x-auto">
      <div className="flex min-w-max gap-1 px-4 py-1.5 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {items.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              `flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-sm font-semibold whitespace-nowrap transition-colors duration-200 ${
                isActive
                  ? 'bg-accent text-white'
                  : 'text-soft hover:bg-raised hover:text-content'
              }`
            }
          >
            <Icon size={14} />
            {label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};
